/** @format */

export enum PayPalCheckoutEnv {
    PRODUCTION = 'production',
    SANDBOX = 'sandbox',
}
